import {RoleService} from "../roles/RoleService";
import {RolePermissionsType} from "../../models/roles/types/RolePermissionsType";
import {EntityService} from "../entity/EntityService";
import {ProductType} from "../../models/product/ProductType";

export class PermissionsService {
    static init() {

    }

    static dispose() {

    }

    static admin(): boolean {
        return RoleService.can(RolePermissionsType.ADMINISTRATOR);
    }

    static blogWriting(): boolean {
        return RoleService.can(
            RolePermissionsType.BLOG_WRITING,
            RolePermissionsType.BLOG_ADMINISTRATOR,
            RolePermissionsType.BLOG_PUBLISH
        );
    }

    static blogWritingInCommunity(communityId: string): boolean {
        return RoleService.canInCommunity(communityId,
            RolePermissionsType.BLOG_WRITING,
            RolePermissionsType.BLOG_ADMINISTRATOR,
            RolePermissionsType.BLOG_PUBLISH
        );
    }

    static blogLoad(): boolean {
        return RoleService.can(
            RolePermissionsType.BLOG_READING,
            RolePermissionsType.BLOG_WRITING,
            RolePermissionsType.BLOG_ADMINISTRATOR,
            RolePermissionsType.BLOG_PUBLISH
        );
    }

    static whiteLabel(): boolean {
        return RoleService.can(RolePermissionsType.WHITE_LABEL);
    }

    /**
     * features (white label disable flags) - present means disabled
     */

    static featureAlya(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_AGENT_ALYA)
            : !RoleService.has(RolePermissionsType.DISABLE_AGENT_ALYA);
    }

    static featureRemi(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_AGENT_REMI)
            : !RoleService.has(RolePermissionsType.DISABLE_AGENT_REMI);
    }

    static featureMaya(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_AGENT_MAYA)
            : !RoleService.has(RolePermissionsType.DISABLE_AGENT_MAYA);
    }

    static featureNox(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_AGENT_NOX)
            : !RoleService.has(RolePermissionsType.DISABLE_AGENT_NOX);
    }

    static featureMarc(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_AGENT_MARC)
            : !RoleService.has(RolePermissionsType.DISABLE_AGENT_MARC);
    }

    static featureLuca(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_AGENT_LUCA)
            : !RoleService.has(RolePermissionsType.DISABLE_AGENT_LUCA);
    }

    static featureMax(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_AGENT_MAX)
            : !RoleService.has(RolePermissionsType.DISABLE_AGENT_MAX);
    }

    static inboxReading(communityId?: string): boolean {
        return communityId
            ? RoleService.canInCommunity(communityId, RolePermissionsType.INBOX_READING, RolePermissionsType.INBOX_REPLY)
            : RoleService.can(RolePermissionsType.INBOX_READING, RolePermissionsType.INBOX_REPLY);
    }

    static inboxReply(communityId?: string): boolean {
        return communityId
            ? RoleService.canInCommunity(communityId, RolePermissionsType.INBOX_REPLY)
            : RoleService.can(RolePermissionsType.INBOX_REPLY);
    }

    static establishmentReading(communityId?: string): boolean {
        return communityId
            ? RoleService.canInCommunity(communityId, RolePermissionsType.ESTABLISHMENT_READING, RolePermissionsType.ESTABLISHMENT_WRITING, RolePermissionsType.ESTABLISHMENT_IDENTITY)
            : RoleService.can(RolePermissionsType.ESTABLISHMENT_READING, RolePermissionsType.ESTABLISHMENT_WRITING, RolePermissionsType.ESTABLISHMENT_IDENTITY);
    }

    static establishmentWriting(communityId?: string): boolean {
        return communityId
            ? RoleService.canInCommunity(communityId, RolePermissionsType.ESTABLISHMENT_WRITING, RolePermissionsType.ESTABLISHMENT_IDENTITY)
            : RoleService.can(RolePermissionsType.ESTABLISHMENT_WRITING, RolePermissionsType.ESTABLISHMENT_IDENTITY);
    }

    static establishmentIdentity(communityId?: string): boolean {
        return communityId
            ? RoleService.canInCommunity(communityId, RolePermissionsType.ESTABLISHMENT_IDENTITY)
            : RoleService.can(RolePermissionsType.ESTABLISHMENT_IDENTITY);
    }

    static featureSeoVisibility(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_SEO_VISIBILITY)
            : !RoleService.has(RolePermissionsType.DISABLE_SEO_VISIBILITY);
    }

    static featureLlmVisibility(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_LLM_VISIBILITY)
            : !RoleService.has(RolePermissionsType.DISABLE_LLM_VISIBILITY);
    }

    static featureLocalVisibility(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_LOCAL_VISIBILITY)
            : !RoleService.has(RolePermissionsType.DISABLE_LOCAL_VISIBILITY);
    }

    static featureTools(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_TOOLS)
            : !RoleService.has(RolePermissionsType.DISABLE_TOOLS);
    }

    static featureImagesEdit(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_IMAGES_EDIT)
            : !RoleService.has(RolePermissionsType.DISABLE_IMAGES_EDIT);
    }

    static featureHelpCenter(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_HELP_CENTER)
            : !RoleService.has(RolePermissionsType.DISABLE_HELP_CENTER);
    }

    static featureIndexation(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_INDEXATION)
            : !RoleService.has(RolePermissionsType.DISABLE_INDEXATION);
    }

    static featureSiteConfigConnections(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_SITE_CONFIG_CONNECTIONS)
            : !RoleService.has(RolePermissionsType.DISABLE_SITE_CONFIG_CONNECTIONS);
    }

    static featureSiteConfigBrand(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_SITE_CONFIG_BRAND)
            : !RoleService.has(RolePermissionsType.DISABLE_SITE_CONFIG_BRAND);
    }

    static featureSiteConfigSettings(communityId?: string): boolean {
        return communityId
            ? !RoleService.hasInCommunity(communityId, RolePermissionsType.DISABLE_SITE_CONFIG_SETTINGS)
            : !RoleService.has(RolePermissionsType.DISABLE_SITE_CONFIG_SETTINGS);
    }

    /**
     * product
     */

    static canProduct(type: ProductType): boolean {
        if (!EntityService.activeSite) {
            return false;
        }
        return EntityService.activeSite.products.includes(type);
    }

    /**
     * utilities
     */
    static d(permission: boolean): string {
        return permission ? `` : `display:none;`;
    }

    static o(permission: boolean): string {
        return permission ? `` : `opacity:0.3;pointer-events:none;`;
    }

}